{
  " Delete Company": "Supprimer Entreprise",
  "%Auto": "%Auto",
  "%Total": "%Total",
  "1st year of": "1er exercice du",
  "500 - INTERNAL ERROR": "500 - ERREUR INTERNE",
  "Absence management": "Gestion des absences",
  "Analytical accounting": "Comptabilité analytique",
  "Access SSI": "Accès SSI",
  "access_denied": "Cette page n’existe pas ou vous n’y avez pas accès.",
  "Accesses": "Accès",
  "Account": "Compte",
  "Account disabled": "Compte bancaire désactivé",
  "Account Manager": "Portefeuille",
  "Account Number": "Numéro de Compte",
  "Account prefix": "Préfixe compt",
  "Account type ": "Type de compta",
  "ACCOUNT_MANAGER": "Portefeuille",
  "Accounting": "Paramètres Comptables",
  "Accounting balance review": "Dossier de révision bilan",
  "Accounting balance review completed": "Dossier de révision bilan terminé",
  "Accounting firm": "Cabinet comptable",
  "Accounting Firm": "Cabinet Comptable",
  "Accounting firm addresses": "Adresse du cabinet",
  "Accounting firm banks": "Banques du cabinet",
  "Accounting firm contacts": "Contacts du cabinet",
  "Accounting firm platforms": "Plateformes du cabinet",
  "Accounting firm settings": "Paramètres du cabinet",
  "Accounting firm uses Neoscan-Expert": "Cabinet utilise Neoscan Expert?",
  "Accounting firms": "Cabinets Comptables",
  "Accounting Firms": "Cabinets Comptables",
  "Accounting Plan Type": "Type de plan comptable",
  "Accountingfirm company": "Dossier Cabinet",
  "Accounts linked to the bank": "Comptes liés à la banque",
  "Accounts without integration": "Comptes sans intégration",
  "Action": "Action",
  "Actions": "Actions",
  "Active": "Actif",
  "Active cycle": "Exercice actif",
  "Activity code": "Code d'activité",
  "Add": "Ajouter",
  "Add Access to user": "Ajouter un accès à l'utilisateur",
  "Add Account": "Ajouter Compte",
  "Add Accounting Firm": "Ajouter un cabinet comptable",
  "Add address": "Ajoutez une adresse",
  "Add Address": "Ajoutez une adresse",
  "Add Assignment": "Ajouter une affectation",
  "Add Assignments": "Ajouter des affectations",
  "Add Attachments": "Ajout Partenaire",
  "Add bank": "Ajouter une Banque",
  "Add Bank": "Ajouter une Banque",
  "Add bank account": "Ajouter un compte bancaire",
  "Add book": "Ajouter un Journal",
  "Add category": "Ajouter catégorie",
  "Add client": "Ajouter compte client",
  "Add Client": "Ajouter Client",
  "Add client user": "Ajouter un utilisateur client",
  "Add Colaborator": "Ajouter un collaborateur",
  "Add Collecting Organization": "Ajouter organismes collecteurs",
  "Add company": "Ajouter une entreprise",
  "Add Company": "Ajouter Entreprise",
  "Add compte Client": "Ajouter compte client",
  "Add compte Provider": "Ajouter compte fournisseur",
  "Add counterpart": "Ajouter compte général",
  "Add Counterpart": "Ajouter compte général",
  "Add custom graphic": "Ajouter un graphique personnalisé",
  "Add cycle": "Ajouter Exercice",
  "Add Director": "Ajouter un directeur",
  "Add Director/StakeHolder": "Ajouter un directeur",
  "Add Email": "Ajouter un Email",
  "Add Establishment": "Ajouter un établissement",
  "Add existing client user": "Ajouter utilisateur client existant",
  "Add existing user": "Ajouter un utilisateur existant",
  "Add external Service": "Ajouter un service externe",
  "Add line": "Ajouter une ligne",
  "Add Member": "Ajouter Membre",
  "Add new bank": "Ajouter une banque",
  "Add new bank account": "Ajouter un compte bancaire",
  "Add new company": "Ajouter nouvelle entreprise",
  "Add new user": "Ajouter nouvel utilisateur",
  "Add Phone": "Ajouter un Téléphone",
  "Add platform": "Ajouter une Plateforme",
  "Add Provider": "Ajouter compte Fournisseur",
  "Add Stakeholder": "Ajouter associer",
  "Add user": "Ajouter un utilisateur ",
  "Add Vat": "Ajouter TVA",
  "Add Worktime": "Ajouter temps de travail",
  "Addons": "Services Collaboratifs",
  "Address": "Adresse",
  "Address 1": "Adresse 1",
  "Address 2": "Adresse 2",
  "Address 3": "Adresse 3",
  "Address type": "Type d'adresse",
  "Address Type": "Type d'adresse",
  "Address_plural": "Adresses",
  "Address1": "Adresse 1",
  "Address2": "Adresse 2",
  "Address3": "Adresse 3",
  "Addresses": "Adresses",
  "admin_cabinet": "Administrateur",
  "admin_newrai": "Administratif",
  "Advanced Export": "Export avancé",
  "Advanced import": "Importation avancée",
  "AGIRIS": "Agiris",
  "All": "Tout",
  "Allowance for professional expenses": "Allocation pour frais professionnels",
  "Amount": "Amount",
  "An error occurred, please refresh the page or click the button below": "Une erreur s'est produite, veuillez actualiser la page ou cliquez sur le bouton ci-dessous",
  "An unexpected error occurred processing your request, please try again later.": "Une erreur inattendue s'est produite lors du traitement de votre demande, veuillez réessayer plus tard.",
  "Analyze": "Analyser",
  "API URL": "API URL",
  "apiUrl": "API URL",
  "APIURL": "API URL",
  "App": "App",
  "Application": "Application",
  "Arbitration of leave": "Arbitrage du congé",
  "Are you sure about custom graphic?": "Êtes-vous sûr du graphique personnalisé ?",
  "Are you sure about delete this": "Êtes-vous sûr de vouloir supprimer",
  "Are you sure about delete this address?": "Êtes-vous sûr de vouloir supprimer adresse",
  "Are you sure about delete this assignment?": "Êtes-vous sûr de vouloir supprimer cette affectation?",
  "Are you sure about delete this bank account?": "Êtes-vous sûr de supprimer ce compte bancaire?",
  "Are you sure about delete this bank?": "Êtes-vous sûr de vouloir supprimer cet banque?",
  "Are you sure about delete this cycle?": "Êtes-vous sûr de vouloir supprimer ce cycle?",
  "Are you sure about delete this establishment?": "Voulez-vous vraiment supprimer cet établissement ?",
  "Are you sure about delete this keyword?": "Êtes-vous sûr de vouloir supprimer ce mot clé ?",
  "Are you sure about delete this platform?": "Êtes-vous sûr de vouloir supprimer cet plateforme?",
  "Are you sure about delete this user": "Êtes-vous sûr de vouloir supprimer cet utilisateur",
  "Are you sure that you want to delete the accesses to this accounting firm?": "Êtes-vous sûr de vouloir supprimer les accès à ce cabinet comptable ?",
  "Are you sure that you want to remove this user from this company?": "Voulez-vous vraiment supprimer cet utilisateur de cette entreprise ?",
  "Are you sure you want to delete this bank?": "Voulez-vous vraiment supprimer cet banque ?",
  "Are you sure you want to delete this category?": "Êtes-vous sûr de vouloir supprimer cette catégorie ?",
  "Are you sure you want to delete this company?": "Êtes-vous sûr de vouloir supprimer cette entreprise ?",
  "Are you sure you want to delete this vat?": "Êtes-vous sûr de vouloir supprimer cette TVA?",
  "Are you sure you want to do a new import?": "Êtes-vous sûr de vouloir faire une nouvelle importation?",
  "Are you sure you want to re-export this/these journal entry(ies) to the accounting software?": "Êtes-vous sûr de vouloir réexporter ce(s) écriture(s) comptable(s) vers le logiciel de comptabilité?",
  "Are you sure you want to remove this user ?": "Êtes-vous sûr de vouloir supprimer cet utilisateur ?",
  "Are you sure you want to save the data in this period? After saving it is not possible to change this period.": "Voulez-vous vraiment enregistrer les données pendant cette période? Après l’enregistrement, il n’est pas possible de modifier cette période.",
  "Are you sure you want to start this bulk?": "Êtes-vous sûr de vouloir démarrer ce lot ?",
  "Are you sure you want to start this scanbulk?": "Etes-vous sûr de vouloir démarrer ce bulk?",
  "Are you sure you want to unsubscribe the newsletter?": "Êtes-vous sûr de vouloir vous désinscrire de la newsletter ?",
  "Assign this bulk": "Attribuer ce lot",
  "Assigned to": "Attribuer à",
  "Assignment Type": "Type d'affectation",
  "Assignments": "Affectations",
  "at": "à",
  "At least 1 email": "Au moins 1 e-mail",
  "At least 1 phone": "Au moins 1 téléphone",
  "atc": "Agent technico comptable",
  "ATC": "ATC",
  "ATC Name": "Nom de L'ATC",
  "Attachment successfully inserted": "Pièce jointe insérée avec succès",
  "Auto Export FACT": "Exportation Auto FACT",
  "Auto Export NCS": "Exportation Auto NCS",
  "Auto Export NeoCheque": "Exportation Auto NeoCheque",
  "Auto Export NeoFrais": "Exportation Auto NeoFrais",
  "Auto Export NeoTreso": "Exportation Auto NeoTreso",
  "Auto Export SSI": "Exportation Auto SSI",
  "Auto exported": "Exportation automatique",
  "Auto Import Success": "Succès d'Import Auto",
  "Auto Liquidation": "Liquidation Automatique",
  "Available": "Disponible",
  "Available soon": "Bientôt disponible",
  "AZUR": "Azur",
  "AZURPC": "Azur Plan Comptable",
  "Back to list": "Retour à la liste",
  "Bank": "Banque",
  "Bank account": "Compte bancaire",
  "Bank account deleted": "Compte bancaire supprimé",
  "Bank accounts": "Comptes bancaires",
  "Bank compte was saved with success": "Le compte bancaire a été enregistré avec succès",
  "Bank description": "Description de la banque",
  "Bank Description": "Description de la banque",
  "Bank does not exist": "Le banque n'existe pas",
  "Bank saved with success": "Banque sauvée avec succès",
  "Banks": "Banques",
  "Banks connections": "Connexions à la banque",
  "Bar chart": "Graphique à barres",
  "Benefits": "Prestations",
  "BIC / SWIFT": "BIC / SWIFT",
  "BILLING": "Facturation",
  "Book Bank": "Journal Banque",
  "Book cashed checks (Income)": "Journal: Chèques Encaissés (Recettes)",
  "Book issued checks (Expense)": "Journal: Chèques Emis (Dépenses)",
  "Book Saved with Success": "Journal enregistré avec succès",
  "Book Type": "Type de Journal",
  "Books": "Journaux",
  "BTQ": "BTQ",
  "Bulk": "Lot",
  "Business Activity": "Activités commerciales",
  "Business Name": "Nom de l'Entreprise",
  "Buys": "Achats",
  "Calculation": "Calcul",
  "Calendar of obligations": "Calendrier des obligations",
  "Calendar of obligations - Vat": "Calendrier des obligations - TVA",
  "Cancel": "Annuler",
  "Capital Amount": "Montant du Capital",
  "Cashed sales": "Vtes encaissées",
  "Cashed turnover": "CA encaissé",
  "Category": "Catégorie",
  "CDI CDIR": "CDI CDIR",
  "CEGID": "CEGID",
  "Center Dep. Plate": "Centre Dép. Assiette",
  "CFE": "CFE",
  "Change declare TVA": "Modifier votre TVA",
  "Change Password": "Changer le mot de passe",
  "Chargé portefeuille": "Chargé portefeuille",
  "Chorus": "Chorus",
  "City": "Ville",
  "Clé": "Clé",
  "Clear": "Annuler",
  "Click or drag file to this area to upload": "Cliquez ou faites glisser le fichier dans cette zone pour le télécharger",
  "Client": "Client",
  "Client account": "Compte client",
  "Client ID": "Client ID",
  "Client Info": "Informations client",
  "Client Saved with Success": "Client enregistré avec succès",
  "Client secret": "Client secret",
  "Client secrets": "Client secrets",
  "Client support": "Support Client",
  "Client type": "Type de client",
  "Client was removed from this company with success": "Le client a été supprimé de cette entreprise avec succès",
  "Client was saved with success": "Le client a été enregistré avec succès",
  "Client_user": "Utilisateur Client",
  "Clients": "Comptes Clients",
  "Close": "Fermer",
  "Closing month of leave": "Dernier mois de congé",
  "cm": "Chef de mission",
  "CNX": "CNX",
  "Code": "Code",
  "Code de TVA": "Code de TVA",
  "Code Service": "Code Service",
  "Code TVA": "Code TVA",
  "COFI": "COFI",
  "Collaborator": "Collaborateur",
  "COLLABORATOR": "Collaborateur",
  "Collaborator was created with success": "Collaborator a été créé avec succès",
  "Collaborator was saved with success": "Le collaborateur a été enregistré avec succès",
  "Collaborators": "Collaborateurs",
  "Collabs": "Collabs",
  "Collections": "Encaissements",
  "Collective": "Collectif",
  "Collective agreement": "Convention collective",
  "Collective by default": "Collectif par défaut",
  "Collector Institutions": "Organismes collecteurs",
  "Commentary": "Commentaire",
  "Comments": "commentaires",
  "Companies": "Entreprises",
  "Company": "Entreprise",
  "Company Name": "Nom du dossier",
  "Company successfully deleted ": "Entreprise supprimée avec succès",
  "Company weekly schedule": "Planning hebdomadaire de l'entreprise",
  "Complementary Addresses": "Adresses Complémentaires",
  "Compt. Auto": "Compt. Auto",
  "Config Business Activity": "Configurer l'activité commerciale",
  "Configured": "Configuré",
  "Confirm": "Confirmer",
  "Confirm deletion": "Confirmer la suppression",
  "Confirm that you want to deactivate the connection?": "Confirmez-vous que vous souhaitez désactiver la connexion?",
  "Confirmation": "Confirmation",
  "Connect to bank": "Connectez-vous à la banque",
  "Connected": "Connecté",
  "Connection": "Connexion",
  "Connection Errors": "Erreurs de connexion",
  "Contacts": "Contacts",
  "Copy email": "Copier e-mail",
  "Counter Collective": "Compte Collectif",
  "Counterpart": "Contrepartie",
  "Counterpart autoliquidation": "Contrepartie autoliquidation",
  "Counterpart Bank": "Compte Banque",
  "Counterpart Buy": "Contrepartie Achats",
  "Counterpart cashed checks (Income)": "Compte: Chèques Encaissés (Recettes)",
  "Counterpart code": "Code",
  "Counterpart code SSI": "Compte SSI",
  "Counterpart code Tréso": "Compte Tréso",
  "Counterpart Immobilization": "Contrepartie Immobilisation",
  "Counterpart issued checks (Expense)": "Compte: Chèques Emis (Dépenses)",
  "Counterpart saved with success": "Compte enregistré avec succès",
  "Counterpart Sell": "Contrepartie Ventes",
  "Counterpart SSI": "Compte SSI",
  "Counterpart Tréso": "Compte Tréso",
  "counterpart_len": "Le code doit comporter {{count}} caractères",
  "counterpart_len_one": "Le code doit comporter {{count}} caractères",
  "counterpart_len_many": "Le code doit comporter {{count}} caractères",
  "counterpart_len_other": "Le code doit comporter {{count}} caractères",
  "Country": "Pays",
  "Couterparts by cycle": "Compte par exercice",
  "cp": "Dossier externalisé",
  "CP": "Dossier externalisé",
  "cp_alternative": "Chargé Portefeuille",
  "Create": "Créer",
  "Create account": "Création de compte",
  "Create accounts without integration": "Créer des comptes sans intégration",
  "Create bank account": "Créer un compte bancaire",
  "Create bank counterparts": "Créer compte bancaires",
  "Create bank cycle": "Créer un cycle de contrepartie",
  "Create new user": "Créer un nouvel utilisateur",
  "Create/manage accounts linked to the bank": "Créer/gérer des comptes liés à la banque",
  "Created": "Créé",
  "Created by": "Créateur",
  "Created By Newrai": "Créé par Newrai",
  "created successfully": "créé avec succès",
  "Creation Date": "Date de Création",
  "Currency": "Devise",
  "Currency Tracking": "Suivi des devises",
  "current customers": "Clients en cours",
  "Current Debits": "Débits en cours",
  "Current month and year": "Mois et année en cours",
  "Custom graphics": "Graphiques personnalisés",
  "CVAE Déclaration": "CVAE Déclaration",
  "CVAE Paiement": "CVAE Paiement",
  "Cycle": "Exercice",
  "Cycle Saved with Success": "Exercice enregistré avec succès",
  "Cycles": "Exercices",
  "Date": "Date",
  "Date - Time": "Date - Heure",
  "Date format:": "Format de date:",
  "Date of last election": "Date de la dernière élection",
  "Date of payment of wages": "Date de paiement du salaire",
  "Day": "Jour",
  "Deactivate the company": "Désactiver la société",
  "Debits": "Débits",
  "Declare VAT": "Soumis TVA",
  "Declared sales": "Ventes déclarées",
  "declareVatActive": "Attention, vous avez des écritures en cours dans SSI sans Tva. Si vous activer la Tva vous devrez retourner en SSI pour actualiser votre saisie.",
  "declareVatActive_one": "Attention, vous avez des écritures en cours dans SSI sans Tva. Si vous activer la Tva vous devrez retourner en SSI pour actualiser votre saisie.",
  "declareVatActive_many": "Attention, vous avez des écritures en cours dans SSI sans Tva. Si vous activer la Tva vous devrez retourner en SSI pour actualiser votre saisie.",
  "declareVatActive_other": "Attention, vous avez des écritures en cours dans SSI sans Tva. Si vous activer la Tva vous devrez retourner en SSI pour actualiser votre saisie.",
  "declareVatActive_plural": "Attention, vous avez des écritures en cours dans SSI sans Tva. Si vous activer la Tva vous devrez retourner en SSI pour actualiser votre saisie.",
  "declareVatInactive": "Attention, vous avez des écritures en cours dans SSI le fait de décocher cette option supprimera les valeurs de Tva des {{count}} documents: vous devez retourner sur SSI pour les vérifier.",
  "declareVatInactive_one": "Attention, vous avez des écritures en cours dans SSI le fait de décocher cette option supprimera les valeurs de Tva des {{count}} documents: vous devez retourner sur SSI pour les vérifier.",
  "declareVatInactive_many": "Attention, vous avez des écritures en cours dans SSI le fait de décocher cette option supprimera les valeurs de Tva des {{count}} documents: vous devez retourner sur SSI pour les vérifier.",
  "declareVatInactive_other": "Attention, vous avez des écritures en cours dans SSI le fait de décocher cette option supprimera les valeurs de Tva des {{count}} documents: vous devez retourner sur SSI pour les vérifier.",
  "declareVatInactive_plural": "Attention, vous avez des écritures en cours dans SSI le fait de décocher cette option supprimera les valeurs de Tva des {{count}} documents: vous devez retourner sur SSI pour les vérifier.",
  "Default book": "Journal par défaut",
  "Default book Bank": "Journal par défault",
  "Default clients constants": "Constantes des clients par défaut",
  "Default counterpart": "Compte par défaut",
  "Default Counterpart": "Contreparties par Défaut",
  "Default counterpart Bank": "Compte par Défault",
  "Default document naming": "Nommage des documents par défaut",
  "Default notification e-mail": "Email de notification par défaut",
  "Default notification email": "Email de notification par défaut",
  "Default providers counterparts": "Constantes des fournisseurs par défaut",
  "Default SSI type": "Type SSI par défaut",
  "Default SSI Type": "Type SSI par défaut",
  "Delete": "Supprimer",
  "Delete bank": "Supprimer banque",
  "Delete bank account": "Supprimer le compte bancaire",
  "Delete custom graphic": "Supprimer le graphique personnalisé",
  "Delete keyword": "Supprimer mot clé",
  "Delete success": "Supprimé avec succès",
  "Delete this company": "Supprimer cette entreprise",
  "Delete user access": "Supprimer l'accès utilisateur",
  "Delete vat": "Supprimer TVA",
  "Deleted Successfully": "Supprimé avec succès",
  "Deliver statement": "Déclaration",
  "DELIVERY": "Livraison",
  "Description": "Description",
  "Details": "Détails",
  "director": "Direction",
  "Director": "Dirigeant",
  "Director/StakeHolder saved with success": "Dirigent/Associé enregistré avec succès",
  "Directors": "Dirigeant",
  "Disable bank account": "Désactiver le compte bancaire",
  "Do you intend to remove this assignments": "Voulez-vous supprimer ces affectations",
  "Do you intend to remove this director": "Voulez-vous supprimer ces dirigeant",
  "Do you intend to remove this stakeholder": "Voulez-vous supprimer ces associés",
  "Do you realy want revert the changes?": "Voulez-vous vraiment annuler les modifications?",
  "Do you realy want update accounting Firm data?": "Voulez-vous vraiment mettre à jour les données du cabinet comptable?",
  "Do you realy want update company data?": "Voulez-vous vraiment mettre à jour les données de l'entreprise?",
  "Do you want to duplicate the plan comptable data from cycle": "Souhaitez-vous dupliquer les données du plan comptable de l'exercice",
  "Docs not charged": "Docs non imputés",
  "Document count": "Numéros chronologiques des pièces",
  "Documents": "Documents",
  "Documents validated / total": "Documents validés / total",
  "Done": "Fait",
  "Dossier": "Dossier",
  "Dossier progres": "Avancement du dossier",
  "Dossier progress": "Avancement du dossier",
  "Download": "Télécharger",
  "duplicate": "Souhaitez-vous dupliquer les données du plan comptable de l'exercice {{x}} à l'exercice {{y}}?",
  "Duplicate the plan comptable": "Dupliquer le plan comptable",
  "Duplicate the plan comptable saved with success": "Dupliquer le plan comptable enregistré avec succès",
  "Duration": "Durée",
  "Economic and social committee": "Comité économique et social",
  "EDI TVA": "EDI TVA",
  "Edit": "Éditer",
  "Edit accounting firm": "Éditer Cabinet Comptable",
  "Edit addons": "Éditer Services Collaboratifs",
  "Edit address": "Éditer adresse",
  "Edit Address": "Modifier l'adresse",
  "Edit Assignments": "Modifier les affectations",
  "Edit bank": "Éditer banque",
  "Edit bank account": "Modifier le compte bancaire",
  "Edit bank counterparts": "Modifier comptes bancaires",
  "Edit bank cycle": "Modifier exercice bancaire",
  "Edit client user": "Éditer l'utilisateur client",
  "Edit Director/StakeHolder": "Modifier Dirigeant/Associés",
  "Edit keyword": "Modifier mot clé",
  "Edit platform": "Éditer plateforme",
  "Electronic payments": "Téle-paiements",
  "Elements to exclude": "Elements à exclure",
  "Email": "Email",
  "Email not valid": "Email non valide",
  "Email_plural": "Emails",
  "Employer/Employee breakdown": "Répartition employeur/employé",
  "Enable two-factor authentication": "Activer l'authentification multifacteur",
  "End": "Fin",
  "End connection with powens": "Terminer la connexion avec powens",
  "End date": "Date fin",
  "End Date": "Date de licenciement",
  "End of exercise": "Fin d'exercice",
  "End Term Date": "Date Fin Mandat",
  "Engagement": "Engagement",
  "English": "Anglais",
  "Enter the day of the TVA declaration in the Fiscal tab": "Saisissez le jour de la déclaration de TVA dans l’onglet Fiscal",
  "Enter your code here, please!": "Entrez votre code ici, s'il vous plaît !",
  "Entity Type": "Type d'entité",
  "ENTREPRISE": "Entreprise",
  "error": "Erreur",
  "Error": "Erreur",
  "Error 404": "Erreur 404",
  "Error code": "Code d'erreur",
  "Error inserting an attachment": "Erreur lors de l'insertion d'une pièce jointe",
  "Error on add service": "Erreur lors de l'ajout de service",
  "Error on delete": "Erreur lors de la suppression",
  "Error on delete Address": "Erreur lors de la suppression de l'adresse",
  "Error on delete Platform": "Erreur lors de la suppression de la plate-forme",
  "Error on export": "Erreur de l'exportation",
  "Error on get data": "Erreur lors de l'obtention des données",
  "Error on get options": "Erreur lors de l'obtention des options",
  "Error on save": "Erreur lors de l'enregistrement",
  "Error on update Address": "Erreur lors de la mise à jour de l'adresse",
  "Error on update banks": "Erreur lors de la mise à jour des banques",
  "Error on update Platform": "Erreur lors de la mise à jour de la plate-forme",
  "Error on update service": "Erreur lors de la mise à jour de service",
  "Error on update settings": "Erreur lors de la mise à jour des paramètres",
  "Error synchronisation": "Erreur de synchronisation",
  "Errors": "Commentaires",
  "Establishment": "Établissement",
  "Establishments": "Établissements",
  "Example": "Exemple",
  "Exclude elements": "Elements à exclure",
  "Exercise is mandatory": "Renseigner la date d'exercice",
  "Exercises": "Exercices",
  "Exit without save": "Quitter sans enregistrer",
  "Expected date of receipt": "Date de réception prévue",
  "Expenses categories": "Catégories de dépenses",
  "Export": "Export",
  "Export  Ascii": "Exporter Ascii",
  "Export Ascii": "Export Ascii",
  "Export Auto": "Exporter Auto",
  "Export Auto SSI": "Export Auto SSI",
  "Export error": "Erreur d'exportation",
  "Export message": "Message d'exportation",
  "Export XLSX": "Exporter XLSX",
  "External Services": "Services externes",
  "External Services Add": "\nServices externes Ajouter",
  "Failed to save client addons": "Erreur lors de l'enregistrement des services collaboratifs",
  "Failed to save user": "Erreur lors de l'enregistrement de l'utilisateur",
  "Failed to update user permissions": "Erreur lors de la mise à jour des permissions de l'utilisateur",
  "Fax": "Fax",
  "FEC": "FEC",
  "File progress": "Avancement du dossier",
  "Finished": "Terminé",
  "First name": "Prénom",
  "First Name": "Prénom",
  "form": "Formation",
  "France": "France",
  "French": "Français",
  "Frequency": "Fréquence",
  "Friday": "Vendredi",
  "From": "De",
  "FRP Code": "Code FRP",
  "FULL": "Tenue externalisée",
  "General": "Généralités",
  "General Account": "Comptes Généraux",
  "General Accounts": "Comptes Généraux",
  "General Constants": "Constants Générales",
  "General constants saved with success": "Constants générales enregistré avec succès",
  "General info": "Informations Générales",
  "General settings": "Paramètres généraux",
  "Account structure": "Structure des comptes",
  "General lenght": "Généraux",
  "General_Info": "Informations Générales",
  "Go back": "Retourner",
  "Go Back": "Retourner",
  "Go to Home": "Aller à la page d'accueil",
  "Governament mileage costs detailed": "Barèmes kilométriques du gouvernement",
  "Grand total": "Total général",
  "Graphic": "Graphique",
  "HALF": "NewRai digital",
  "Headquarters": "Siége",
  "HelpDesk": "Support client",
  "Highlighted row": "Ligne en surbrillance",
  "History": "Historique",
  "Holiday": "Fériés",
  "Home": "Accueil",
  "Hr Accountant": "Social",
  "HR_ACCOUNTANT": "Social",
  "HT": "HT",
  "Iban": "IBAN",
  "IBAN": "IBAN",
  "Id": "Id",
  "ID": "ID",
  "If NINEA has 7 digits, add 00 at the beginning": "Si NINEA a 7 chiffres, ajoutez 00 au début",
  "If the company is deactivated, it will no longer appear in the lists": "Si la société est désactivée, elle n’apparaitra plus dans les listes",
  "If you delete this company you will no longer be able to access it": "Si vous supprimez cette entreprise, vous ne pourrez plus y accéder.",
  "Image must be smaller than 2MB!": "L'image doit être inférieure à 2 Mo !",
  "Immutable elements": "Elements immuables",
  "Impor Type": "Type Impôt",
  "Import": "Importer",
  "Import / Export": "Importer / Exporter",
  "Import Auto": "Importer Auto",
  "Import Code": "Code Impôt",
  "Import Export Auto": "Importer Exporter Automatiquement",
  "Import file": "Importer le fichier",
  "Import Manual": "Importation Manuelle",
  "Import plan comptable": "Importer le plan comptable",
  "Import Success": "Succès d'importation",
  "Imported": "Importé",
  "In processing": "En cours",
  "Inactive": "Inactif",
  "Inactive cycle": "Exercice inactif",
  "Increase your account's security by enabling two-factor authentication (2FA) : ": "Augmentez la sécurité de votre compte en activant l'authentification multifacteur (MFA) : ",
  "Increase your account's security by enabling two-factor authentication (2FA).": "Améliorez la sécurité de votre compte de connexion en activant la double authentification (2FA)",
  "Independet Worker": "Régime TNS - RSI",
  "Info": "Informations",
  "Information receiver": "Affectation du dossier",
  "Insert the code exactly as the accounting software platform.": "Insérez le code exactement le même que celui de la plateforme logicielle de comptabilité.",
  "Institution type": "Type d'organismes",
  "Instructions": "Instructions",
  "Internal code": "Code interne",
  "Internal Code": "Code interne",
  "Internal reference": "Référence interne",
  "Internal Reference": "Référence Interne",
  "Invalid format": "Format non valide",
  "IR": "IR - Impôt / Revenus",
  "IS": "IS - Impôt / Société",
  "Is active": "C'est actif",
  "Is Active": "C'est Actif",
  "Is connected": "Est connecté",
  "is required": "est requis",
  "IS_unique": "IS",
  "It is not possible to enter the application": "Il n'est pas possible de saisir l'application",
  "It was removed with success": "Il a été supprimé avec succès",
  "Job": "Fonction",
  "Keyword": "Mot-clé",
  "Keywords": "Mots clés",
  "Label": "Étiquette",
  "Language": "Langue",
  "Last name": "Nom",
  "Last Name": "Nom",
  "Last sync": "Dernière synchronisation",
  "Last Update": "Dernière mise à jour",
  "Legal": "Juridique",
  "Legal Accountant": "Juridique",
  "Legal Category": "Catégorie Juridique",
  "Legal Structure": "Structure Jurid.",
  "LEGAL_ACCOUNTANT": "Juridique",
  "Legal_Directors": "Dirigeant",
  "Legal_Info": "Informations",
  "Legal_Stakeholders": "Associés",
  "Legal_Tax": "Fiscal",
  "Legend": "Légende",
  "Length of counterparts": "Longueur des comptes",
  "Limit date": "Date limite",
  "limit_characters": "Assurez-vous que cette valeur comporte au plus {{limit}} caractères (actuellement {{current}}).",
  "Line": "Ligne",
  "Line chart": "Graphique linéaire",
  "List Articles": "Liste des articles",
  "List Companies": "Liste des entreprises",
  "Load more": "Charger plus",
  "Loading": "En chargement",
  "Loading...": "En chargement...",
  "Login": "Login",
  "Logo": "Logo",
  "Logout": "Déconnexion",
  "Lot details": "Détails du lot",
  "Lot ID": "Num. du lot",
  "Machine Learning progress": "Avancement Machine Learning",
  "MAIN": "Principale",
  "Main Accountant": "Expert",
  "Main bank": "Banque principale",
  "Main Bank": "Banque Principale",
  "MAIN_ACCOUNTANT": "Expert",
  "Manage in Powens": "Gérer sur Powens",
  "Manual Export": "Exportation Manuelle",
  "Manual Export FACT": "Exportation Manuelle FACT",
  "Manual Export ncs": "Exportation Manuelle NCS",
  "Manual Export NCS": "Exportation Manuelle NCS",
  "Manual Export NeoCheque": "Exportation Manuelle NeoCheque",
  "Manual Export NeoFrais": "Exportation Manuelle NeoFrais",
  "Manual Export NeoTreso": "Exportation Manuelle NeoTreso",
  "Manual Export ssi": "Exportation Manuelle SSI",
  "Manual Export SSI": "Exportation Manuelle SSI",
  "Manual Import": "Importation Manuelle",
  "max_mileage_cost": "{{max}} CV et plus",
  "Membership nr": "Numéro de membre",
  "Membership of a professional union": "Adhésion à un syndicat professionnel",
  "Method": "Méthode",
  "min_mileage_cost": "{{min}} CV et moins",
  "MISSION CHIEF": "Chef de mission",
  "Missions": "Missions",
  "Monday": "Lundi",
  "Month": "Mois",
  "Month of absence": "Mois d'absence",
  "Month/Year": "Mois / Année",
  "Monthly": "Mensuel",
  "MONTHLY": "Mensuel",
  "Months": "Mois",
  "Mopeds": "Cyclomoteurs",
  "Most used counterpart": "Comptes les plus utilisés",
  "Must be {{length}} characters long": "Doit comporter {{length}} caractères",
  "Must start with {{prefix}}": "Doit commencer par {{prefix}}",
  "MYUNISOFT": "MyUnisoft",
  "Name": "Nom",
  "Name Generator": "Générateur de nom",
  "Net amount": "Montant HT",
  "New": "Nouveau",
  "New bank account": "Nouveau compte bancaire",
  "New company": "Nouvelle entreprise",
  "New Password": "Nouveau mot de passe",
  "newRai": "newRai",
  "NewRai Digital Uses Neoscan": "NewRai Digital utilise Neoscan",
  "Newrai support": "Support Newrai",
  "Newrai user": "Collaborateur Newrai",
  "Newrai User": "Collaborateur Newrai",
  "Newrai user data": "Données d'utilisateur NewRAI",
  "Newsletter": "Newsletter",
  "Newsletter subscribed successfully": "Newsletter souscrite avec succès",
  "Newsletter unsubscribed uccessfully": "Désabonnement à la newsletter",
  "Nic": "Nic",
  "NIC": "NIC",
  "NII": "NII",
  "NINEA": "NINEA",
  "NINEA must have 9 digits": "NINEA doit avoir 9 chiffres",
  "no": "non",
  "No": "Non",
  "No accounting cycles found. Please import the plan comptable first.": "Aucun cycle comptable trouvé. Veuillez d’abord importer le plan comptable.",
  "No balance review sheet exists for the selected cycle": "Aucun bilan n’existe pour le cycle sélectionné",
  "No comments": "Aucun commentaire",
  "No Data": "Aucune donnée",
  "No options": "Aucune option",
  "No Options": "Aucune option",
  "No platform": "Pas de Plateforme",
  "No records found": "Pas de Données",
  "Nominate Date": "Date Nomin.",
  "NONE": "Tenue cabinet",
  "Notifications": "Notifications",
  "Notify": "Affectation du dossier",
  "Nr": "Numéro",
  "NR": "Numéro",
  "Nr Shares": "Nbre de parts",
  "Number": "Numéro",
  "Numéro de Compte": "Numéro de Compte",
  "OCR statistical report": "Rapport statistique Machine Learning",
  "Ok": "Ok",
  "Old Password": "Ancien mot de passe",
  "Oops Page Not Found": "Page introuvable",
  "ops": "Operateur de saisie",
  "Optimizable elements": "Elements optimisables",
  "OPTIONAL": "OPTIONNEL",
  "Order": "Ordre",
  "Other": "Autre",
  "OTHER": "Autres",
  "Others": "Autres",
  "Outside paied package": "Hors forfait payant",
  "Overtime hours charged": "Heures supplémentaires facturées",
  "Paid leave management": "Gestion des congés payés",
  "Participation agreement": "Accord de participation",
  "PARTICULAR": "Particulier",
  "Password": "Mot de passe",
  "Password change": "Changement de mot de passe",
  "Pay Offset": "Décalage de salaire",
  "payment method": "mode de règlement",
  "Payment method": "Mode de règlement",
  "Payment methods": "Modes de règlement",
  "Payment Methods": "Modes de règlement",
  "Payment VLU": "Paiement VLU",
  "Payroll taxes": "Charges sociales",
  "Percentage": "Pourcentage",
  "Period": "Période",
  "Periodic": "Périodique",
  "Permission error": "Erreur de permission",
  "Permission error occurred, if this continues contact support.": "Une erreur de permission s'est produite, si cela continue, contactez le support.",
  "Permissions": "Permissions",
  "Personal identification number": "Numéro d'identification personnel",
  "Phone": "Téléphone",
  "Phone 1": "Téléphone 1",
  "Phone 2": "Téléphone 2",
  "Phone_plural": "Téléphone",
  "Pie chart": "Camembert",
  "Plan Code": "Code Régime",
  "Platform": "Plateforme",
  "Platform deleted with success": "Platforme supprimée avec succès",
  "Platform type": "Type de plateforme",
  "Platform Type": "Type de Plateforme",
  "Please confirm that the MDB file you want to import corresponds to the company you selected. Are you sure you want to import the MDB file?": "Veuillez confirmer que le fichier MDB que vous souhaitez importer correspond à la entreprise que vous avez sélectionnée. Êtes-vous sûr de vouloir importer le fichier MDB?",
  "Please contact admin.": "Veuillez contacter l'administrateur.",
  "Please contact your company's accountant": "Veuillez contacter le cabinet comptable de votre entreprise",
  "Please correct the errors before saving": "Veuillez corriger les erreurs avant d’enregistrer",
  "Please go back to the list and select another one.": "Veuillez revenir à la liste et en sélectionner une autre.",
  "Please input email or delete this field.": "Veuillez saisir un email ou supprimer ce champ.",
  "Please input phone or delete this field.": "Veuillez entrer le téléphone ou supprimer ce champ.",
  "Please insert MDB file": "Veuillez insérer le fichier MDB",
  "Please note that this import will irreversibly affect the data!": "Veuillez noter que cette importation affectera les données de manière irréversible!",
  "Please select the services at Accounting firm": "Veuillez sélectionner les services chez Cabinet comptable",
  "Postal code": "Code postal",
  "Postal Code": "Code Postal",
  "Power": "Puissance",
  "Previous": "Précédente",
  "Price / KM": "Prix par km",
  "Privacy": "Politique de confidentialité",
  "Profile": "Profil",
  "Profit": "Marge Commerciale",
  "Profit-sharing agreement": "Accord d'intéressement",
  "Progress": "Progrès",
  "Progress OCR": "Progrès d'Machine Learning",
  "Progress SSI": "Avancement SSI",
  "Provider": "Fournisseur",
  "Provider account": "Compte fournisseur",
  "Provider Saved with Success": "Fournisseur enregistré avec succès",
  "Providers": "Comptes Fournisseurs",
  "PUBLIC_ADMINISTRATION": "Administration Publique",
  "Purchase allocation": "Ventilation achats Caisse",
  "QUADRA": "Quadra",
  "QUADRAOD": "Quadra On Demand",
  "QUADRAPC": "Quadra Plan Comptable",
  "Quantity Tracking": "Suivi des quantités",
  "Quantity Tracking2": "Suivi des quantités2",
  "QUARTER": "Trimestre",
  "quarterly": "trimestriel",
  "Rate": "Taux",
  "RCM": "RCM",
  "RCS": "RCS",
  "Read More": "Lire plus",
  "readyForExport": "Il y a {{countReady}} documents prêts à être exportés",
  "readyForExportProcessing": "Il y a {{countProcessing}} documents en cours de traitement. Lorsque tout est traité, vous pouvez le télécharger.",
  "readyForExportReadyAndProcessing": "Il y a {{countReady}} documents prêts à être exportés et {{countProcessing}} en cours. Lorsque tout est traité, vous pouvez le télécharger.",
  "Receive notifications by email": "Reception des notifications par email",
  "Receive the newsletter": "Réception de la newsletter",
  "Recipe": "Recette",
  "Reconciliation": "Lettrable",
  "Reconnect": "Se reconnecter",
  "Record": "Enregistrement",
  "Recover company": "Récupérer l'entreprise",
  "Reexport": "Réexporter",
  "Refresh": "Rafraîchir",
  "Refresh page": "Rafraîchir la page",
  "Refresh Page": "Rafraîchir la page",
  "Regime": "Régime",
  "registration": "enregistrement",
  "Remote accounting firm id": "ID du cabinet dans le serveur",
  "Remote Accounting Firm ID": "ID du cabinet dans le serveur",
  "Remove address": "Supprimer l'adresse",
  "Remove Address": "Supprimer l'adresse",
  "Remove Bank": "Supprimer la banque",
  "Remove client user from company": "Supprimer l'utilisateur client de l'entreprise",
  "Remove Platform": "Supprimer Plateforme",
  "Remove user from company": "Supprimer un utilisateur de l'entreprise",
  "removed successfully": "supprimé avec succès",
  "Repeat New Password": "Retaper le nouveau mot de passe",
  "Request password reset": "Demander un nouveau mot de passe",
  "Required action": "Action requise",
  "Reset": "Réinitialiser",
  "Reset user password": "Réinitialisation du mot de passe",
  "Restaurant tickets": "Tickets restaurant",
  "Return": "Annuler",
  "rev": "Reviseur",
  "Salary maintenance": "Maintien du salaire",
  "Sales allocation": "Ventilation ventes Caisse",
  "Saturday": "Samedi",
  "Sauv.": "Sauv.",
  "Save": "Enregistrer",
  "Save & Close": "Sauv. et fermer",
  "Save & Next": "Sauv. et suivant",
  "Save accounting firm with success": "Cabinet comptable sauvé avec succès",
  "Save and Exit": "Sauvegarder et quitter",
  "Save success": "Enregistré avec succès",
  "Save Success": "Enregistré avec succès",
  "Save Successfully": "Enregistré avec succès",
  "Saved": "Enregistré",
  "Saved successfully": "Enregistré avec succès",
  "Saved Successfully": "Enregistré avec succès",
  "Search": "Rechercher",
  "Select": "Sélectionner",
  "Select a country": "Choisissez un pays",
  "Select a service or there are added services that have not yet been saved": "Sélectionnez un service ou il y a des services ajoutés qui n'ont pas encore été enregistrés",
  "Select a type": "Sélectionnez un type\n",
  "Select a user": "Sélectionnez un utilisateur",
  "Select accounting": "Sélectionnez un compte comptable",
  "Select accounting firm": "Sélectionnez cabinet",
  "Select Accounting Firm First": "Sélectionnez d'abord le cabinet comptable",
  "Select adress type": "Sélectionnez type d'adresse",
  "Select an option": "Sélectionnez une option",
  "Select book": "Sélectionnez un Journal",
  "Select book bank": "Sélectionnez type de journaux banque",
  "Select book type": "Sélectionnez type de journaux",
  "Select business activity": "Sélectionner l'activité commerciale",
  "Select city": "Sélectionnez une ville",
  "Select code": "Sélectionner code",
  "Select company": "Sélectionner une entreprise",
  "Select counter collective": "Compte Collectif",
  "Select counterpart": "Sélectionnez une Compte",
  "Select Counterpart": "Sélectionnez une Compte",
  "Select counterpart bank": "Sélectionner contrepartie banque",
  "Select counterpart buy": "Sélectionner contrepartie achats",
  "Select counterpart immobilization": "Sélectionner contrepartie immobilisation",
  "Select counterpart sell": "Sélectionner contrepartie ventes",
  "Select country": "Sélectionnez pays",
  "Select cycle": "Sélectionner exercise",
  "Select cycle type": "Sélectionnez le type de exercice",
  "Select date": "Sélectionner une date",
  "Select default counterpart": "contreparties par défaut",
  "Select establishment": "20 / 5 000\nResultados da tradução\nSélectionnez l'établissement",
  "Select job": "Sélectionner fonction",
  "Select legal category": "Sélectionnez la catégorie juridique",
  "Select legal structure": "Sélectionnez la structure juridique",
  "Select period": "Sélectionner une période",
  "Select plan code": "Sélectionner code régime",
  "Select platform": "Sélectionnez logiciel",
  "Select postal code": "Sélectionnez code postal",
  "Select Services": "Sélectionnez les services",
  "Select services by user": "Sélectionnez les services par utilisateur",
  "Select the platform": "Sélectionnez la Plateforme",
  "Select the SSI Type": "Sélectionnez le type SSI",
  "Select type": "Sélectionnez type",
  "Select user": "Sélectionner utilisateur",
  "Select vat": "Sélectionnez tva",
  "Selected": "Choisi",
  "Sells": "Chiffre d'Affaires",
  "Sells and Buys": "Chiffre d'affaires et Achats",
  "SEMESTER": "Semestre",
  "Send": "Envoyer",
  "Send document": "Envoi des documents",
  "Sénegal": "Sénégal",
  "Sénégal": "Sénégal",
  "SEPA Credential Identifier": "Identifiant Créancier SEPA",
  "Separated by:": "Caractères séparateurs:",
  "Service": "Service",
  "Service type": "Type de service",
  "Services": "Services Collaboratifs",
  "Services by Company": "Prestations par entreprise",
  "Services by User": "Services par utilisateur",
  "Settings": "Paramètres",
  "Settings saved successfully": "Paramètres enregistrés avec succès",
  "Shares Types": "Détention",
  "Short name": "Nom court",
  "Short Name": "Nom Court",
  "Shortname": "Nom Court",
  "Show more": "Voir plus",
  "Siren": "Siren",
  "Siren must have 9 digits": "Siren doit avoir 9 chiffres",
  "Size": "Taille",
  "Skiped": "Ignoré",
  "Social": "Social",
  "Social Dossier": "Dossier Social",
  "Software": "Logiciel",
  "Some banks will be removed because they are duplicates": "Certaines banques seront supprimées car ce sont des doublons.",
  "Some fields need atention": "Certains domaines nécessitent une attention",
  "Specific Info": "Informations spécifiques",
  "SSI progress": "Avancement SSI",
  "SSI type": "Type SSI",
  "SSI Type": "Type SSI",
  "Stakeholder": "Associés",
  "Stakeholders": "Associés",
  "Start": "Début",
  "Start balance review": "Commencer la révision du bilan",
  "Start date": "Date début",
  "Start Date": "Date d'embauche",
  "Start of exercise": "Début d'exercice",
  "Start this bulk": "Démarrer ce lot",
  "Statistics": "Statistiques",
  "Status": "Statut",
  "std": "Collaborateur",
  "Structural overtime": "Heures supplémentaires structurelles",
  "Submit": "Soumettre",
  "Submited by": "Soumis par",
  "Subrogation des IJSS": "Subrogation des IJSS",
  "Subscribe": "S'abonner",
  "Subscribed": "Abonné",
  "Subsidiaries": "Centres analytiques",
  "Subsidiary Type": "Types de Centres analytiques",
  "Success": "Succès",
  "Successful synchronisation": "Synchronisation effectuée avec succès",
  "Successfully created": "Créé avec succès",
  "Successfully removed": "Suppression réussie",
  "Suggestion counterpart": "Compte de suggestion",
  "Suggestion counterpart code": "Code de compte de suggestion",
  "Sunday": "Dimanche",
  "sup": "Superviseur",
  "SURVEILLANCE": "Surveillance",
  "Sync Transactions": "Synchroniser les transactions",
  "Table chart": "Tableau graphique",
  "Tax collection": "Recette des impôts",
  "Tax obligations references": "Références d'obligations Fiscales",
  "Taxation": "Imposition",
  "TDFC": "TDFC",
  "Terminate connection": "Terminer la connexion",
  "Thank you": "Merci pour votre message",
  "The bank that you're looking for does not exist": "Le banque que vous recherchez n'existe pas",
  "The data was saved successfully": "Les données ont été enregistrées avec succès",
  "The data was successfully saved, it may take a few minutes to apply the collaborative services to all companies and their employees.": "Les données ont été enregistrées avec succès, cela peut prendre quelques minutes pour appliquer les services collaboratifs à toutes les entreprises et à leurs employés.",
  "The exercise year ended": "L'exercice terminé",
  "The file was not imported": "Le fichier n'a pas été importé",
  "The Firm": "Le cabinet",
  "The input is not valid e-mail!": "L'entrée n'est pas un e-mail valide !",
  "The input is not valid email!": "Saisissez une adresse de courriel valide.",
  "The page you are looking for does not exist or has been moved.": "La page que vous recherchez n'existe pas ou a été déplacée.",
  "The user will receive an email with a link to reset their password": "Un email sera envoyé à l'utilisateur, accompagné d'un lien permettant de réinitialiser son mot de passe.",
  "There are no documents to export": "Il n'y a aucun document à exporter",
  "There are no documents to export in FACT": "Il n'y a aucun document à exporter en FACT",
  "There are no documents to export in MTL": "Il n'y a aucun document à exporter en MTL",
  "There are no documents to export in NCS": "Il n'y a aucun document à exporter en NCS",
  "There are no documents to export in NeoCheque": "Il n'y a aucun document à exporter en NeoCheque",
  "There are no documents to export in NeoTreso": "Il n'y a aucun document à exporter en NeoTreso",
  "There are no documents to export in SSI": "Il n'y a aucun document à exporter en SSI",
  "There is an error loading the data, please refresh the page or click the button below.": "Une erreur s'est produite lors du chargement des données. Veuillez actualiser la page ou cliquer sur le bouton ci-dessous.",
  "There is an error loading the data, please refresh the page.": "Une erreur s'est produite lors du chargement des données. Veuillez actualiser la page.",
  "There is an error, please refresh the page or click the button below.": "Il y a une erreur, veuillez rafraîchir la page ou cliquer sur le bouton ci-dessous.",
  "There is no connection": "Il n'y a pas de connexion",
  "There is no data to display": "Aucune donnée à afficher",
  "These accounts are connected to your bank, allowing monthly transactions to be automatically retrieved": "Ces comptes sont connectés à votre banque, permettant de récupérer automatiquement les transactions mensuelles",
  "These accounts are purely informative; there is no link with your bank": "Ces comptes sont purement informatifs ; il n'y a aucun lien avec votre banque",
  "Third-part accounts lenght": "Tiers",
  "This action delete the company and all the information it contains. There is no going back": "Cette action supprime le dossier et toutes les informations que le dossier contient. Il n'y a pas de retour en arrière",
  "This action will affect documents.": "Cette action aura une incidence sur {{totalDocuments}} documents.",
  "This action will delete documents.": "Cette action supprime {{totalDocuments}} documents.",
  "This action will disable the bank account and all associated transactions. Are you sure you want to disable this bank account?": "Cette action désactivera le compte bancaire et toutes les transactions associées. Êtes-vous sûr de vouloir désactiver ce compte bancaire ?",
  "This action will permanently delete the bank account and all associated transactions. Are you sure you want to delete this bank account?": "Cette action supprime le compte bancaire et toutes les transactions associées. Êtes-vous sûr de vouloir supprimer ce compte bancaire ?",
  "This field is required": "Ce champ est requis",
  "This field is required or invalid format.": "Ce champ est requis ou format non valide.",
  "This field is required.": "Ce champ est requis.",
  "This field must be a valid url": "Ce champ doit être une URL valide",
  "This field only accept numbers": "Ce champ n'accepte que les chiffres",
  "Thursday": "Jeudi",
  "Tiers": "Tiers",
  "Time": "Heure",
  "Time Length": "Durée",
  "Time limit": "Limite de temps",
  "Timezone": "Fuseau horaire",
  "to": "à",
  "to cycle ": "à l'exercice",
  "Today": "Aujourd'hui",
  "Total": "Total",
  "Total articles": "Total {{count}} article",
  "Total articles_one": "Total {{count}} article",
  "Total articles_many": "Total {{count}} d'articles",
  "Total articles_other": "Total {{count}} d'articles",
  "Total articles_plural": "Total {{count}} d'articles",
  "Total cumulative sales": "Total ventes cumulées",
  "Total Customers period": "Total Clients période",
  "Total docs registered": "Total des docs. enregistrés",
  "Total docs validated": "Total des docs. validés",
  "Total documents": "Total documents",
  "Total Documents": "Total des documents",
  "Total sales cashed": "Total ventes encaissées",
  "Total table items": "Total {{count}} élément",
  "Total table items_one": "Total {{count}} élément",
  "Total table items_many": "Total {{count}} éléments",
  "Total table items_other": "Total {{count}} éléments",
  "Total table items_plural": "Total {{count}} éléments",
  "Transactions imported successfully": "Transactions importées avec succès",
  "Treasury": "Trésorerie",
  "Treasury IS": "Trésorerie IS",
  "Treated": "Validé",
  "Trimest": "Trimestre",
  "TS": "TS",
  "TTC": "TTC",
  "Tuesday": "Mardi",
  "Turnover to be declared": "Ca à déclarer",
  "TVA": "TVA",
  "TVA sur": "TVA sur",
  "Two-factor authentication": "Authentification multifacteur",
  "Type": "Type",
  "Un lock": "Un lock",
  "Unauthorized": "Non autorisé",
  "Undo": "Annuler",
  "Unexpected error": "Erreur inattendue",
  "Unexpected Error": "Erreur inattendue",
  "Unit measure": "Unité de mesure",
  "Unit price": "Prix unitaire",
  "Unlock": "Ouvrir",
  "Unsubscribe": "Se désabonner",
  "Unsubscribed": "Non inscrit",
  "Update": "Modifier",
  "Update bank": "Mise à jour banque",
  "Update Collecting Organization": "Modifier organismes collecteurs",
  "Update custom graphic": "Mettre à jour le graphique personnalisé",
  "Update Establishment": "Modifier Etablissement",
  "Update Worktime": "Modifier le temps de travail",
  "Updated": "Mis à jour",
  "Updated by": "Mis à jour par",
  "updated successfully": "mis à jour avec succès",
  "Upload your file": "Téléchargez votre fichier",
  "Uploaded to Interops": "Téléchargé sur Interops",
  "Upon receipt of SS Indemnities": "Dès réception des indemnités SS",
  "Use the government mileage scales": "Utiliser les barèmes de kilométrage du gouvernement",
  "Use URL file in export": "Utiliser le fichier URL dans l'exportation",
  "User": "Utilisateur",
  "User access": "Accès utilisateur",
  "User Access": "Accès utilisateur",
  "User category": "Catégorie d'utilisateur",
  "User Category": "Catégorie d'utilisateur",
  "User data": "Utilisateur",
  "User info": "Informations utilisateur",
  "User Type": "Type d'utilisateur",
  "Username": "Nom d'utilisateur",
  "Users": "Utilisateurs",
  "Validate": "Valider",
  "Validated": "Validé",
  "value": "valeur",
  "Vat": "TVA",
  "VAT": "TVA",
  "VAT amount": "Montant TVA",
  "VAT autoliquidation": "TVA Autoliquidation",
  "VAT declaration": "Déclaration de TVA",
  "Vat number": "Siren",
  "Vat Number": "Siret",
  "Vat Number_siret": "Siret",
  "Vat Saved with Success": "TVA enregistré avec succès",
  "VAT to be regularized": "Tva à régulariser",
  "Vats": "TVA",
  "Vats control": "Contrôle de la TVA",
  "Warnings": "Avertissements",
  "Web Site": "Site Web",
  "Website": "Site Web",
  "Wednesday": "Mercredi",
  "Without access": "Sans accès",
  "Work shift": "Poste de travail",
  "Work time": "Temps de travail",
  "Worktime": "Temps de travail",
  "WorkTime": "Temps de travail",
  "Write a comment...": "Écrire un commentaire...",
  "YEARLY": "Annuel",
  "Yes": "Oui",
  "YES": "OUI",
  "You are logged out": "Vous êtes déconnecté",
  "You can only upload JPG/PNG file!": "Vous ne pouvez télécharger que des fichiers JPG/PNG!",
  "You do not have access to any company, please contact the accounting firm administrator": "Vous n'avez accès à aucune entreprise, veuillez contacter l'administrateur du cabinet comptable",
  "You have succesfully set up two-factor authentication": "Vous avez configuré avec succès l'authentification multifacteur",
  "You have unsaved changes, are you sure you want to leave?": "Vous avez des modifications non enregistrées, êtes-vous sûr de vouloir partir?",
  "You must add the user to a company": "Vous devez ajouter l'utilisateur à un entreprise"
}
